if (!customElements.get('store-switcher')) {
  customElements.define(
    'store-switcher',
    class StoreSwitcher extends HTMLElement {
        connectedCallback() {
            this.button = this.querySelector('.btn');
            this.store = this.dataset.store;

            this.button.addEventListener('click', this.setCartAttributes.bind(this));
        }

        setCartAttributes(e) {
    e.preventDefault();
    const routingUrl = this.button.href;
    const url = `${FoxTheme.routes.cart_update_url}.js`;

    fetch(url, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        body: JSON.stringify({
            attributes: {
                'store': this.store
            }
        })
    })
    .then(response => {
        if (!response.ok) return response.json().then(err => { throw err; });
        return response.json();
    })
    .then(cart => {
        console.log("Cart attributes updated successfully:", cart);
        
        /* Cache Busting: 
           We append a timestamp (?v=123...) to the URL. 
           This forces the browser to bypass the cache and see the new 'store' attribute.
        */
        const separator = routingUrl.includes('?') ? '&' : '?';
        const freshUrl = `${routingUrl}${separator}cache_bust=${Date.now()}`;
        
        window.location.href = freshUrl;
    })
    .catch(error => {
        console.error("Error updating cart attributes:", error);
        // Fallback: Redirect anyway if the fetch fails so the user isn't stuck
        window.location.href = routingUrl;
    });
        }
    }
  );
}